module.exports = __webpack_public_path__ + "static/onsean-b14f13038393c1adf688caa90234eba7.png";